import React from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Products from "@/components/site/Products";
import HowItWorks from "@/components/site/HowItWorks";
import Services from "@/components/site/Services";
import Industries from "@/components/site/Industries";
import About from "@/components/site/About";
import Testimonials from "@/components/site/Testimonials";
import Clients from "@/components/site/Clients";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import Chatbot from "@/components/site/Chatbot";

export default function Landing() {
  return (
    <div className="bg-white text-zinc-950">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Products />
        <HowItWorks />
        <Services />
        <Industries />
        <About />
        <Clients />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <Chatbot />
    </div>
  );
}
